<template>
    
    <div>
        <NavBar />
         <BeltsHero />
          <BeltProducts /> 
         <FooterPage />
    </div>
     
</template>



<script>
import NavBar from '../components/NavBar.vue'
import  BeltsHero from '../components/BeltsHero.vue'
import BeltProducts from '../components/BeltProducts.vue'
import FooterPage from '../components/FooterPage.vue'

export default {
  components: {
    NavBar, BeltsHero, 
    BeltProducts, 
    FooterPage
  }
}
</script>


<style scoped>
.bags-page {
   padding: 80px 8%;
   text-align: center;
}

.bags-page h1{
    color: #292929;
    font-size: 45px;
}

.bags-page p{
    color: #4a4541;
    font-size: 18px;
    }
</style>